import {LorenMeteringType} from "../loren-assets/interfaces/loren-metering-type";

interface FillLevelDataPoint {
  id?: string;
  key?: string;
  value?: unknown;
}

function findMetering(item: FillLevelDataPoint) {
  return [item?.key, item?.id].includes("fillState");
}

export enum LorenFillLevelState {
  UNKNOWN = 0,
  FULL = 1,
  HALF = 2,
  LOW = 3,
  EMPTY = 4,
}

const allLevelStates = [
    LorenFillLevelState.UNKNOWN,
    LorenFillLevelState.FULL,
    LorenFillLevelState.HALF,
    LorenFillLevelState.LOW,
    LorenFillLevelState.EMPTY,
];


export const LorenFillLevelStateTranslationKeys = new Map<number, string>([
  [LorenFillLevelState.UNKNOWN, "fill_level.unknown"],
  [LorenFillLevelState.FULL, "fill_level.full"],
  [LorenFillLevelState.HALF, "fill_level.half"],
  [LorenFillLevelState.LOW, "fill_level.low"],
  [LorenFillLevelState.EMPTY, "fill_level.empty"],
]);

export const LorenFillLevelStates = allLevelStates.map(
  (value) => ({
    value,
    translationKey: LorenFillLevelStateTranslationKeys.get(value),
  })
);

export function isFillLevelSensor(type: LorenMeteringType | null | undefined) {
  return type === LorenMeteringType.FILL_LEVEL_SENSOR;
}

export function getFillLevelValue(value: unknown): number | null {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue) || !Number.isInteger(parsedValue)) {
    return null;
  }

  return allLevelStates.includes(parsedValue) ? parsedValue : null;
}

export function getFillLevelTranslationKey(value: unknown): string | null {
  const state = getFillLevelValue(value);
  return state === null ? null : LorenFillLevelStateTranslationKeys.get(state);
}

export function getFillLevelValueFromData(
  data: FillLevelDataPoint[] | null | undefined
): LorenFillLevelState | null {
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  const value = data.find(findMetering)?.value;

  if(!value) {
    return null;
  }

  return getFillLevelValue(value);
}

export function getFillLevelTranslationKeyFromData(
  data: FillLevelDataPoint[] | null | undefined
): string | null {
  return getFillLevelTranslationKey(
    data?.find(findMetering)?.value
  );
}
